import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import useLogin from '../../common/hook/useLogin';
import {actions} from '../state/action';
import {IEventTypeV4} from '../type';

interface IProps {
  id: number;
  eventType: IEventTypeV4;
}

export default function useFetchModuleMap({id, eventType}: IProps) {
  const dispatch = useDispatch();
  const {isLoginChecking} = useLogin();

  useEffect(() => {
    if (isLoginChecking) return;

    dispatch(actions.fetchEventModuleMap(eventType, id));
    return () => {
      dispatch(
        actions.setPropertyValues('moduleMap', {
          [eventType]: undefined,
        })
      );
    };
  }, [id, eventType, dispatch, isLoginChecking]);
}
